export type CookieType = 'analytical' | 'essential';

export const COOKIES: Record<'ANALYTICAL' | 'ESSENTIAL', CookieType> = {
  ANALYTICAL: 'analytical',
  ESSENTIAL: 'essential',
} as const;

export const COOKIE_LOCAL_STORAGE_KEY = 'cookie-selection';
